(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cycling subline
    const phrases = document.querySelectorAll('.drifted-hero__phrase');
    let current = 0;

    function cyclePhrase() {
      phrases[current].classList.remove('drifted-hero__phrase--active');
      current = (current + 1) % phrases.length;
      phrases[current].classList.add('drifted-hero__phrase--active');
    }

    if (phrases.length > 1) {
      setInterval(cyclePhrase, 2400);
    }

    // Hide scroll indicator on scroll
    const scrollIndicator = document.querySelector('.drifted-hero__scroll');
    if (scrollIndicator) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
          scrollIndicator.classList.add('drifted-hero__scroll--hidden');
        } else {
          scrollIndicator.classList.remove('drifted-hero__scroll--hidden');
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
